/**
 * @fileOverview This file contains the axiosClient utility function and related constants for making HTTP requests.
 * @module axiosClient
 */

import axios from "axios";
import { encryptAndStoreToken, getDecryptedToken } from "./CryptoJS";
import LocalstorageService from "./localstorage-services";
// import Cookies from "universal-cookie";

axios.defaults.withCredentials = false;
let apiURL = "";
let accountURL = "";

/**
 * Configuration options for the you only environment.
 * @type {Object}
 */
const zaffa = {
  name: "Zaffa",
  account: "",
  api: "https://dev-api.zaffa.app/api/",
  live: "https://zaffa.app/",
};

/**
 * The domain of the application. If you're running the application locally, make sure to add the domain to the .env file.
 * @type {string}
 */
// eslint-disable-next-line no-undef
export const domain = process.env.REACT_APP_DOMAIN;

/**
 * Configuration options for the localhost environment.
 * @type {Object}
 */
const localhost = {
  account: "http://localhost:3000/",
  api: "https://dev-api.zaffa.app/api/",
};

const path = window.location.href;
const live = !!path.match(zaffa.live);

if (live) {
  accountURL = zaffa.account;
  apiURL = zaffa.api;
} else {
  accountURL = localhost.account;
  apiURL = localhost.api;
}

export const API_URL = apiURL;
export const ACCOUNT_URL = accountURL;

const handleUnauthorizedOrForbidden = async () => {
  let user = JSON.parse(localStorage.getItem("zaffa-admin"));
  let tempObj = { refreshToken: getDecryptedToken(user?.refreshToken) };
  try {
    const response = await axios.post(
      `${API_URL}/admin/auth/refreshToken`,
      tempObj,
      {
        headers: {
          Authorization: `Bearer ${getDecryptedToken(user?.token)}`,
        },
      }
    );

    console.log("response", response);

    if (response?.data?.status === 1) {
      user = {
        ...user,
        token: encryptAndStoreToken(response.data.response.accessToken),
      };
      LocalstorageService.loginUser({ user: user });

      // Reload the page or retry the request after token update
      window.location.reload();
    } else {
      LocalstorageService.removeFromLocalStorage("zaffa-admin");
      window.location = "/admin";
    }
  } catch (error) {
    console.error("Failed to refresh token:", error);
    LocalstorageService.removeFromLocalStorage("zaffa-admin");
    window.location = "/admin";
  }
};

/**
 * The axios client function for making HTTP requests to api.
 * @function axiosClient
 */
export function axiosClient() {
  // gets the email and refresh cookies
  const token = JSON.parse(localStorage.getItem("zaffa-admin"))?.token;

  const defaultOptions = {
    baseURL: apiURL,
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      // "Access-Control-Allow-Credentials": true,
      accept: "application/json",
    },
  };

  const instance = axios.create(defaultOptions);

  if (token) {
    instance.interceptors.request.use(
      (config) => {
        config.headers.Authorization = `Bearer ${getDecryptedToken(token)}`;
        return config;
      },
      (error) => Promise.reject(error)
    );

    instance.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${getDecryptedToken(token)}`;
    instance.interceptors.response.use(
      (response) => response,
      async (error) => {
        const status = error.response?.status;

        // if (status === 403) {
        //   window.location = "/unauthorized";
        //   // await handleUnauthorizedOrForbidden();
        // }

        if (status === 401) {
          await handleUnauthorizedOrForbidden();
        }

        return Promise.reject(error);
      }
    );
  }

  return instance;
}

export default axiosClient;
